import { visitorAccessType } from "src/api/access/ac-group-types";

export const accessGroupTabs = [
  {
    value: "basicInfo",
    label: "기본정보",
  },
  {
    value: "history",
    label: "변경내역",
  },
];

export const accessGroupSearchType = [
  {
    value: "",
    label: "전체",
  },
  {
    value: "id",
    label: "출입그룹 ID",
  },
  {
    value: "accessGroupName",
    label: "출입그룹명",
  },
];

// 목록 조건검색 셀렉트 필터
type AccessGroupSearchFilter = {
  key: "memberAccessYn" | "visitorAccessYn" | "visitorAccessGroupSelectableYn" | "visitorInvitationApprovalYn" | "visitorAccessType" | "floorAccessYn";
  placeholder: string;
  options: { value: string; label: string }[];
  widthClassName?: string; // 미지정 시 minmax140
};

// 전체는 value "" 로 두고, 선택 시 쿼리 파라미터에서 제거한다
export const accessGroupSearchFilters: AccessGroupSearchFilter[] = [
  {
    key: "memberAccessYn",
    placeholder: "이용자 출입 가능 여부",
    options: [
      { value: "", label: "전체" },
      { value: "true", label: "출입가능" },
      { value: "false", label: "출입불가" },
    ],
    widthClassName: "minmax200",
  },
  {
    key: "visitorAccessYn",
    placeholder: "방문자 초대 가능 여부",
    options: [
      { value: "", label: "전체" },
      { value: "true", label: "초대가능" },
      { value: "false", label: "초대불가" },
    ],
    widthClassName: "minmax200",
  },
  {
    key: "visitorAccessGroupSelectableYn",
    placeholder: "앱 노출 여부",
    options: [
      { value: "", label: "전체" },
      { value: "true", label: "노출" },
      { value: "false", label: "노출안함" },
    ],
    widthClassName: "minmax160",
  },
  {
    key: "visitorInvitationApprovalYn",
    placeholder: "관리자 승인 방식",
    options: [
      { value: "", label: "전체" },
      { value: "false", label: "자동승인" },
      { value: "true", label: "승인필요" },
    ],
    widthClassName: "minmax160",
  },
  {
    key: "visitorAccessType",
    placeholder: "QR 발급 여부",
    options: [
      { value: "", label: "전체" },
      { value: visitorAccessType.VISITOR_MUTABLE, label: "발급" },
      { value: visitorAccessType.VISITOR_NO_MUTABLE, label: "미발급" },
    ],
    widthClassName: "minmax160",
  },
  {
    key: "floorAccessYn",
    placeholder: "엘리베이터 연동",
    options: [
      { value: "", label: "전체" },
      { value: "true", label: "ON" },
      { value: "false", label: "OFF" },
    ],
    widthClassName: "minmax160",
  },
];

// CTRLROOM_ACCESS_GROUP_ACCESS_FLOORS feature 비활성 파트너에게는 숨겨야 하는 검색 필터의 key
export const floorAccessSearchFilterKeys: AccessGroupSearchFilter["key"][] = ["floorAccessYn"];

type RadioOption = {
  label: string;
  value: string | boolean;
};
// 라디오 버튼 그룹 타입 정의
type RadioGroupConfig = {
  title: string;
  name: string;
  options: RadioOption[];
  defaultValue?: string | boolean;
  tooltip?: string;
};

export const visitorSettings: RadioGroupConfig[] = [
  {
    title: "앱 노출 여부",
    name: "visitorAccessGroupSelectableYn",
    options: [
      { label: "노출", value: true },
      { label: "노출안함", value: false },
    ],
    tooltip: "노출하지 않는 경우, [Taap > 방문자 초대 > 출입권한]에 해당 출입그룹이 표시되지 않습니다.",
    defaultValue: false,
  },
  {
    title: "관리자 승인 방식",
    name: "visitorInvitationApprovalYn",
    options: [
      { label: "자동승인", value: false },
      { label: "승인필요", value: true },
    ],
    tooltip: "[방문자 초대 > 출입권한]에서 '승인필요'한 출입그룹을 포함하여 초대하는 경우, 관리자 승인 후에 방문자에게 초대장이 발송됩니다.",
    defaultValue: false,
  },
  {
    title: "QR 발급 여부",
    name: "visitorAccessType",
    options: [
      { label: "발급", value: visitorAccessType.VISITOR_MUTABLE },
      { label: "미발급", value: visitorAccessType.VISITOR_NO_MUTABLE },
    ],
    tooltip: "미발급하는 경우, 방문자에게 QR코드 비활성화된 초대장이 발송됩니다.",
    defaultValue: visitorAccessType.VISITOR_NO_MUTABLE,
  },
];
